import Vue from 'vue'
const vm = new Vue()

const api = {}
/**
 * 查询企业信息
 *
 */
api.getEnterprise = function (id) {
    let url = `/kj-kyc/eKyc/getEnterprise?enterpriseId=${id}`
    return vm.$http.get(url)
}
/**
 * 查询国家数据
 *
 */
api.getCountry = function (queObj) {
    let url = `/kj-kyc/country/list`
    return vm.$http.post(url, queObj)
}
/**
 * 保存企业信息
 *
 */
api.saveEnterprise = function (queObj) {
    let url = `/kj-kyc/eKyc/saveClientEnterprise`
    return vm.$http.post(url, queObj)
}
/**
 * 暂存企业信息
 *
 */
api.stagedEnterprise = function (queObj) {
    let url = `/kj-kyc/eKyc/stagedEnterprise`
    return vm.$http.post(url, queObj)
}
/**
 * 查询授权人信息
 *
 */
api.getManager = function (id) {
    let url = `/kj-kyc/eKyc/getManager?enterpriseId=${id}`
    return vm.$http.get(url)
}
/**
 * 保存授权人信息
 *
 */
api.saveManager = function (queObj) {
    let url = `/kj-kyc/eKyc/saveManager`
    return vm.$http.post(url, queObj)
}
/**
 * 暂存授权人信息
 *
 */
api.stagedManager = function (queObj) {
    let url = `/kj-kyc/eKyc/stagedManager`
    return vm.$http.post(url, queObj)
}
/**
 * 查询企业联系人信息（除授权人）
 *
 */
api.getEnterpriseContact = function (id) {
    let url = `/kj-kyc/eKyc/getEnterpriseContact?enterpriseId=${id}`
    return vm.$http.get(url)
}
/**
 * 保存企业联系人信息（除授权人）
 *
 */
api.saveEnterpriseContact = function (queObj) {
    let url = `/kj-kyc/eKyc/saveEnterpriseContact`
    return vm.$http.post(url, queObj)
}
/**
 * 暂存企业联系人信息（除授权人）
 *
 */
api.stagedEnterpriseContact = function (queObj) {
    let url = `/kj-kyc/eKyc/stagedEnterpriseContact`
    return vm.$http.post(url, queObj)
}
/**
 * 实名认证提交
 *
 */
api.ekycSubmit = function (enterObj, queObj) {
    let url = `/kj-kyc/eKyc/submit/${enterObj.enterpriseId}/${enterObj.mediaId}`
    return vm.$http.post(url, queObj)
}
/**
 * 上传文件
 *
 */
api.uploadFile = function (mediaId, modelCode, catgId, queObj, specifyFileName) {
    let url = `/kj-media/media/opera/do/uploadMediaFile?modelCode=${modelCode}&catgId=${catgId}&busiKey=${mediaId}&sysCode=KJ_SYSTEM&specifyFileName=${specifyFileName}`
    return vm.$http.post(url, queObj)

}
/**
 * 上传文件-ocr相关
 *
 */
api.uploadFileOCR = function (mediaId, modelCode, catgId, queObj, specifyFileName) {
    let url = `/kj-kyc/enterprise/uploadMediaFile?modelCode=${modelCode}&catgId=${catgId}&busiKey=${mediaId}&specifyFileName=${specifyFileName}`
    return vm.$http.post(url, queObj)

}
/**
 * 查询影像件
 *
 */
api.showFileByCatgIdBusiKey = function (mediaId, modelCode, catgId, queObj) {
    let url = `/kj-media/media/opera/do/showFileByCatgIdBusiKey?modelCode=${modelCode}&catgId=${catgId}&busiKey=${mediaId}&sysCode=KJ_SYSTEM`
    return vm.$http.post(url, queObj)

}
/**
 * 删除单个影像件
 *
 */
api.deleteFileByFileId = function (modelCode, fileId, queObj) {
    let url = `/kj-media/media/opera/do/deleteFileByFileId?modelCode=${modelCode}&fileId=${fileId}&sysCode=KJ_SYSTEM`
    return vm.$http.post(url, queObj)

}
/**
 * 提交成功调用工作流
 *
 */
api.claimAndCompleteTaskByBusId = function (id, query) {
    let url = `/kj-wkfl/wkfl/claimAndCompleteTaskByBusId?auditState=pass&businessId=${id}&processDefKey=kj_kyc_audit&taskDefKey=usr-kjKycFstCheck`
    return vm.$http.post(url, query)
}
/**
 * 虚拟账户开户表下载
 *
 */
api.downAccountAgreement = function (id, query) {
    let url = `/kj-kyc/eKyc/downAccountAgreement/${id}`
    return vm.$http.post(url, query, { responseType: 'blob' })
}
/**
 * 获取开户协议（境外）
 *
 */
api.getAccountAgreement = function (id) {
    let url = `/kj-kyc/eKyc/getAccountAgreement?enterpriseId=${id}`
    return vm.$http.get(url)
}
/**
 * 校验初始化企业信息
 *
 */
api.checkEnterprise = function (query) {
    let url = `/kj-kyc/eKyc/checkEnterprise`
    return vm.$http.post(url, query)
}
/**
 * 校验授权人是否和当前登录用户一致
 *
 */
api.validateUserAssociation = function(queObj) {
    let url = `kj-sys/user/validateUserAssociation`
    return vm.$http.post(url, queObj)
  }
/**
 * 更新授权人信息
 *
 */
api.editManageUser = function(queObj) {
let url = `kj-sys/user/editManageUser`
return vm.$http.post(url, queObj)
}

export default api